import { toast } from 'react-toastify';

function showCopyErrorToast(error?: string) {
  const massage = 'Could not copy text';

  if (error) {
    console.debug(`${massage}: `, error);
  }

  toast.error(`${massage}. Please do it manually`);
}

export function copyToClipboardWithToast(text: string) {
  if (!text) {
    return;
  }

  if (!navigator.clipboard) {
    showCopyErrorToast('navigator.clipboard is not available');
    return;
  }

  navigator.clipboard.writeText(text).then(
    () => {
      toast.success('Copied to clipboard!', { toastId: 'copyToClipboard' });
    },
    (error) => {
      showCopyErrorToast(error);
    },
  );
}
